import React from "react";
import ReactDOM from "react-dom";
import "./MoreFeatureShow.css";

export default function MoreFeatureShow({
  isOpen,
  title,
  inclusions = [],
  onClose,
  isBid = false,
}) {
  // Don't render modal if closed
  if (!isOpen) return null;

  // Modal content
  const modalContent = (
    <div className="inclusions-modal-overlay" onClick={onClose}>
      <div
        className="inclusions-modal"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button className="inclusions-modal-close-btn" onClick={onClose}>
          ✕
        </button>

        <h3 className="inclusions-title">{title}</h3>

        <div className="inclusions-list">
          {isBid ? (
            Object.entries(inclusions || {})
              .filter(([key]) => !["package_name"].includes(key)) // exclude fields
              .map(([key, value], index) => (
                <span key={index} className="inclusion-pill">
                  {key.replace(/_/g, " ")}: {value}
                </span>
              ))
          ) : (
            inclusions.map((item, index) => (
              <span key={index} className="inclusion-pill">
                {item?.title}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );

  // Render modal via portal
  return ReactDOM.createPortal(modalContent, document.body);
}
